import Link from 'next/link'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { XLogo } from '@/components/ui/x-logo'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerSections = [
    {
      title: 'Company',
      links: [
        { label: 'About Us', href: '/about' },
        { label: 'Careers', href: '/careers' },
        { label: 'Blog', href: '/blog' },
      ],
    },
    {
      title: 'Product',
      links: [
        { label: 'Features', href: '/features' },
{ label: 'Pricing', href: '/pricing' },
        { label: 'AI & Analytics', href: '/ai-analytics' },
        { label: 'Regulations', href: '/regulations' },
        { label: 'API', href: '/api-docs' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', href: '/privacy-policy' },
        { label: 'Terms of Service', href: '/terms-of-service' },
        { label: 'Cookie Policy', href: '/cookie-policy' },
        { label: 'Security', href: '/security' },
      ],
    },
    {
      title: 'Support',
      links: [
        { label: 'Documentation', href: '/documentation' },
        { label: 'Glossary', href: '/glossary' },
        { label: 'Changelog', href: '/changelog' },
        { label: 'Status', href: '/status' },
        { label: 'Contact Support', href: '/contact' },
      ],
    },
  ]

  return (
    <footer className="border-t bg-background relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none dark:bg-gradient-to-tr dark:from-transparent dark:via-primary/[0.03] dark:to-primary/[0.08]" />
      <div className="absolute inset-0 pointer-events-none dark:bg-gradient-to-b dark:from-primary/[0.05] dark:via-transparent dark:to-transparent" />
      <div className="container mx-auto px-4 py-12 relative">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      href={link.href}
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="border-t pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-muted-foreground">
              © {currentYear} GovCon Data. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <Link
                href="https://x.com/GovConData"
                className="text-muted-foreground hover:text-foreground transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <XLogo className="h-5 w-5" />
                <span className="sr-only">Twitter</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

